import useGetLocation from './useGetLocation'

export default useGetLocation
